import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Spinner from './Spinner';
import Image from './Image';

const ResetByAnswer = ({
  data = {},
  type = '',
  resetByAnswer = () => {},
  handleBack = () => {}
}) => {
  const initialValues = {
    answer: '',
  };

  const validate = () => {
    return Yup.object().shape({
      answer: Yup.string().required('Hãy nhập thông tin'),
    });
  };

  const handleFormSubmit = (data, resetForm) => {
    const resetLevel = type == 'PASSWORD_TYPE_2' ? 'CẤP 2' : type == 'PASSWORD_TYPE_3' ? 'CẤP 3' : ''
    resetByAnswer(data.answer, resetLevel);
  };

  const handleBackHome = (e) => {
    e.preventDefault()
    handleBack()
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={validate()}
      initialValues={initialValues}
      onSubmit={(values, { resetForm }) => handleFormSubmit(values, resetForm)}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting
      }) => (
        <form action="" className="lock-account" onSubmit={handleSubmit}>
          <div className="form-group lock-account__name">
            <label htmlFor="questionInput">Câu hỏi bí mật của bạn</label>
            <input
              type="text"
              name="question"
              id="questionInput"
              value={data.configuration.secret_question_method?.question}
              className="form-control"
              disabled
              readOnly
            />
          </div>
          <div className="form-group lock-account__name">
            <label htmlFor="answerInput">Câu trả lời</label>
            <input
              type="text"
              name="answer"
              id="answerInput"
              value={values.answer}
              className={`form-control ${errors.answer && touched.answer ? 'is-invalid' : ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.answer && touched.answer && (<div className="invalid-feedback">{errors.answer}</div>)}
          </div>
          <div className="lock-account__submit">
            {data.isResettingByAnswer ? <Spinner/> : (
              <>
                <a href="#" className="btn-back btn-hover-scale" onClick={e => handleBackHome(e)}>Quay lại</a>
                <button type="submit" className="btn-hover-scale" title="Xác nhận">
                  <Image src="images/btn-submit.png"/>
                </button>
              </>
            )}
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ResetByAnswer;
